/** PageActionBar içindeki butonlar — tek kaynak */
export const PAGE_ACTION_BUTTON_HEIGHT = 40;

/** py: 2 (16px × 2) + buton yüksekliği */
export const PAGE_ACTION_BAR_MIN_HEIGHT = PAGE_ACTION_BUTTON_HEIGHT + 32;

export const pageActionButtonSx = {
  minHeight: PAGE_ACTION_BUTTON_HEIGHT,
  height: PAGE_ACTION_BUTTON_HEIGHT,
  borderRadius: 2,
  px: 1.75,
  py: 0.5,
  fontSize: "0.875rem",
  fontWeight: 600,
  textTransform: "none",
  "& .MuiSvgIcon-root": {
    fontSize: "1.1rem",
  },
};
